import { render, staticRenderFns } from "./kpEdit.vue?vue&type=template&id=5be87a74&scoped=true&"
import script from "./kpEdit.vue?vue&type=script&lang=ts&"
export * from "./kpEdit.vue?vue&type=script&lang=ts&"
import style0 from "./kpEdit.vue?vue&type=style&index=0&id=5be87a74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be87a74",
  null
  
)

export default component.exports